import { BreakPoints } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		[BreakPoints.tabletCompactHeight]: {
			height: 'auto',
		},
	},
});
